export const MAINTENANCE_TASK_PART_STOCK_ARTICLE_FIELD_NAME = "stockArticleId";
export const MAINTENANCE_TASK_PART_AMOUNT_FIELD_NAME = "amount";
